/* eslint max-params: [0] */
import { linkModifiers, linksToModify, domains } from '../data/constants.js';
import { enlist, ensure } from '../utils';

function classes(...classNames) {
  classNames = classNames.filter(className => className);
  return classNames.length ? `class="${classNames.join(' ')}"` : '';
}

function stringifyAttributes(attributes = {}) {
  return !attributes
    ? ''
    : Object.keys(attributes)
        .map(attribute => `${attribute}="${attributes[attribute]}"`)
        .join(' ');
}

export function linkContent(item, classNames, tabIndex, contentItemAttributes) {
  const DEFAULT_TAG = 'span';

  item.contentAttrs = item.contentAttrs || {};
  const hasSubs = item.subs && item.subs.length;
  if (item.href) {
    item.tag = 'a';
    item.contentAttrs.href = item.href;
    if (item.rel) {
      item.contentAttrs.rel = item.rel;
    }
    if (item.target) {
      item.contentAttrs.target = item.target;
    }
  }
  item.tag = item.tag || DEFAULT_TAG;

  const attributes = Object.keys(item.contentAttrs)
    .map(attribute => (item.contentAttrs[attribute] ? `${attribute}="${item.contentAttrs[attribute]}"` : ''))
    .join(' ');

  return `
    <${item.tag}
      ${attributes}
      ${stringifyAttributes(contentItemAttributes)}
      ${classes(...enlist(item.contentClasses, (classNames || {}).itemContent))}
      ${typeof tabIndex === 'number' && (hasSubs || item.tag === 'a') ? `tabindex="${tabIndex}"` : ''}
      ${hasSubs ? `aria-haspopup="true"` : ''}
      ${item.tab ? `data-bi-tab="${item.tab}"` : ''}
      ${item.subTab ? `data-bi-sub-tab="${item.subTab}"` : ''}
      ${item.name ? `data-bi-name="${item.name}"` : ''}
      ${item.dataHook ? `data-hook=${item.dataHook}` : ''}
    >
      ${ensure(item.text) || ''}
      ${ensure(item.extraContent) || ''}
    </${item.tag}>
  `;
}

export function link(
  item,
  classNames,
  classNamesForSubs,
  tabIndex,
  listAttributes = {},
  itemAttributes = {},
  contentItemAttributes = {},
) {
  const attributes = Object.keys(item.attrs || {})
    .map(attribute => `${attribute}="${item.attrs[attribute]}"`)
    .join(' ');
  const hasSubs = item.subs && item.subs.length;
  return `
    <li ${attributes} ${classes(
    ...enlist(classNames.item, item.classes, hasSubs ? classNames.hasSubmenu : null),
  )} ${stringifyAttributes(itemAttributes)}>
      ${linkContent(item, classNames, tabIndex, contentItemAttributes)}
      ${
        hasSubs
          ? links(
              item.subs,
              classNamesForSubs || classNames,
              null,
              tabIndex,
              listAttributes,
              itemAttributes,
              contentItemAttributes,
            )
          : ''
      }
    </li>
  `;
}

export function links(
  list = [],
  classNames = {},
  classNamesForSubs = null,
  tabIndex = null,
  listAttributes = {},
  itemAttributes = {},
  contentItemAttributes = {},
  dataHook = '',
) {
  const listClassNames = classNames.list instanceof Function ? classNames.list(list) : classNames.list;
  return `
    <ul ${classes(...enlist(listClassNames))} ${stringifyAttributes(listAttributes)} data-hook="${dataHook}">
      ${list
        .map(item =>
          link(item, classNames, classNamesForSubs, tabIndex, listAttributes, itemAttributes, contentItemAttributes),
        )
        .join('')}
    </ul>
  `;
}

export const modifyLangOnlyLinks = (item, lang) => {
  if (!item || !item.lang) {
    return item;
  }

  return item.lang.indexOf(lang) !== -1 ? item : null;
};

export const homeLink = (language = 'en') => `https://${language === 'en' ? 'www' : language}.${domains.wixNaked}`;

export const modifyLinks = user => (link, lang) => {
  if (!link || !link.href || !link.name) {
    return link;
  }

  const userLink = linksToModify.userLinks[`${link.name}`];
  const generalLink = linksToModify.generalLinks[`${link.name}`];

  if (!(userLink || generalLink)) {
    return link;
  }

  const method = userLink ? userLink : generalLink;
  const modifiedItem = { ...link };
  const modifier = linkModifiers[method][link.name] || linkModifiers[method];

  if (generalLink && modifier[lang]) {
    modifiedItem.href = modifier[lang];
  }

  if (userLink) {
    if (user) {
      modifiedItem.href = modifier.loggedIn;
    } else if (modifier.anonymous && modifier.anonymous[lang]) {
      modifiedItem.href = modifier.anonymous[lang];
    }
  }

  return modifiedItem;
};
